/* close-halo (isolato) */
(() => {
  try {
    const CFG = {
      MODAL: ".gallery-viewer",
      BTN: ".gallery-viewer__button.gallery-viewer__close",
      FIRST_DELAY: 2500,
      REPEAT_EVERY: 8000,
      SCALE_END: 3.6, // <- memorizzato
      RIPPLE_MIN: 2,
      RIPPLE_MAX: 3,
      DURATION_BASE: 950,
      STAGGER: 140,
      RING_BORDER: 2,
      RING_INSET: -8,
      RING_COLOR: "#e10600",
      MAX_REPEATS: 9999,
    };

    let poll = null,
      firstTimer = null,
      loopTimer = null,
      repeats = 0,
      endObs = null;

    const isOpen = (m) => {
      if (!m) return false;
      const aria = m.getAttribute("aria-hidden");
      if (aria === "true") return false;
      const cs = getComputedStyle(m);
      if (
        cs.display === "none" ||
        cs.visibility === "hidden" ||
        parseFloat(cs.opacity) === 0
      )
        return false;
      const btn = m.querySelector(CFG.BTN);
      if (!btn) return false;
      const bs = getComputedStyle(btn);
      if (
        bs.display === "none" ||
        bs.visibility === "hidden" ||
        parseFloat(bs.opacity) === 0
      )
        return false;
      const r = btn.getBoundingClientRect(),
        vw = innerWidth,
        vh = innerHeight;
      return (
        r.width > 0 &&
        r.height > 0 &&
        r.bottom > 0 &&
        r.right > 0 &&
        r.top < vh &&
        r.left < vw
      );
    };

    const ensureContainer = (btn) => {
      let c = btn.querySelector(".close-halo");
      if (!c) {
        const pos = getComputedStyle(btn).position;
        if (pos === "static") btn.style.position = "relative";
        c = document.createElement("span");
        c.className = "close-halo";
        c.style.inset = `${CFG.RING_INSET}px`;
        btn.appendChild(c);
        for (let i = 0; i < CFG.RIPPLE_MAX; i++) {
          const ring = document.createElement("span");
          ring.className = "halo-ring";
          ring.style.borderWidth = `${CFG.RING_BORDER}px`;
          ring.style.borderColor = CFG.RING_COLOR;
          c.appendChild(ring);
        }
      }
      return c;
    };

    const animateOnce = (btn) => {
      const rings = [...ensureContainer(btn).querySelectorAll(".halo-ring")];
      const count =
        Math.floor(Math.random() * (CFG.RIPPLE_MAX - CFG.RIPPLE_MIN + 1)) +
        CFG.RIPPLE_MIN;

      rings.forEach((ring, i) => {
        // Annulla eventuali animazioni precedenti per evitare residui
        ring.getAnimations().forEach((a) => a.cancel());

        // Stato di base
        const active = i < count;
        ring.style.opacity = active ? "1" : "0";
        ring.style.transform = active
          ? "scale(0.6)"
          : `scale(${CFG.SCALE_END})`;

        if (!active) return;

        const delay = i * CFG.STAGGER;
        const anim = ring.animate(
          [
            { transform: "scale(0.6)", opacity: 0.9 },
            { transform: `scale(${CFG.SCALE_END})`, opacity: 0 },
          ],
          {
            duration: CFG.DURATION_BASE + i * 180,
            easing: "ease-out",
            delay,
            fill: "forwards", // mantiene il frame finale mentre è in pausa
          }
        );

        // A prescindere, mettiamo lo stato finale anche inline (nessun “cerchiolino acceso”)
        anim.addEventListener("finish", () => {
          ring.style.opacity = "0";
          ring.style.transform = `scale(${CFG.SCALE_END})`;
        });
      });
    };

    const stop = () => {
      clearTimeout(firstTimer);
      clearInterval(loopTimer);
      endObs && endObs.disconnect();
      endObs = null;
      if (!poll) poll = setInterval(tick, 250);
    };

    const startFor = (modal) => {
      const btn = modal.querySelector(CFG.BTN);
      if (!btn) return;
      repeats = 0;
      firstTimer = setTimeout(() => {
        if (!isOpen(modal)) return;
        animateOnce(btn);
        repeats++;
        loopTimer = setInterval(() => {
          if (!isOpen(modal) || repeats >= CFG.MAX_REPEATS) return stop();
          animateOnce(btn);
          repeats++;
        }, CFG.REPEAT_EVERY);
      }, CFG.FIRST_DELAY);

      endObs = new MutationObserver(() => {
        if (!isOpen(modal)) stop();
      });
      endObs.observe(modal, {
        attributes: true,
        attributeFilter: ["style", "class", "aria-hidden", "open"],
      });
    };

    const tick = () => {
      const m = document.querySelector(CFG.MODAL);
      if (m && isOpen(m)) {
        clearInterval(poll);
        poll = null;
        startFor(m);
      }
    };

    poll = setInterval(tick, 250);
    window.__closeHaloDebug = { tick, stop, cfg: CFG };
  } catch (e) {
    console.error("[close-halo] fatal", e);
  }
})();
